<template>
  <div class="page-footer">
    <div class="main">
      <div class="left" tabindex="0">
        <ul>
          <li class="left-item" tabindex="1">
            <div class="label">联系方式：</div>
            <div class="value">{{ websitInfo.tel }}</div>
          </li>
          <li class="left-item" tabindex="2">
            <div class="label">EMAIL：</div>
            <div class="value">{{ websitInfo.email }}</div>
          </li>
          <li class="left-item" tabindex="3">
            <div class="label">主办单位：</div>
            <div class="value">
              {{ websitInfo.organizational }}
            </div>
          </li>
          <li class="left-item" tabindex="4">
            <div class="label">地址：</div>
            <div class="value">{{ websitInfo.addr }}</div>
          </li>
          <li class="left-item" tabindex="5">
            <div class="label">备案信息：</div>
            <a
              class="value"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
            >
              {{ websitInfo.beian }}
            </a>
          </li>
          <li class="left-item" tabindex="6">
            <div class="label">郑公备：</div>
            <div class="value">{{ websitInfo.zgb }}</div>
          </li>
        </ul>
      </div>
      <div class="center">
        <a
          href="http://search.gjsy.gov.cn/wsss/view"
          class="item shiye"
          tabindex="0"
        >
          <img src="~@/assets/images/shiye.png" class="img" />
        </a>
        <!-- <a
          href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4102050001"
          class="item zhaocuo"
          tabindex="0"
        >
          <img src="~@/assets/images/zhaocuo.png" class="img" />
        </a> -->
      </div>
      <div class="right">
        <div class="ewm-item" v-for="(item, i) in ewmList" :key="i">
          <img :src="item.ewm_image | baseImg" class="img" tabindex="0" />
          <span class="tit">{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsitInfo } from "@/apis/api";
import { getPcIndexEwm } from "@/apis/api";
import { mapMutations } from "vuex";

export default {
  name: "PageFooter",
  data() {
    return {
      ewmList: [],
      websitInfo: {
        tel: "", //电话号码
        email: "", //电子邮箱，比如 example@qq.com
        organizational: "", //主办单位
        addr: "", //地址
        beian: "", //备案号
        zgb: "", //郑公备
        seo_title: "",
        seo_keywords: "",
        seo_description: "",
      },
    };
  },
  metaInfo() {
    return {
      title: this.websitInfo.seo_title,
      meta: [
        {
          name: "keywords",
          content: this.websitInfo.seo_keywords,
        },
        {
          name: "description",
          content: this.websitInfo.seo_description,
        },
      ],
    };
  },
  created() {
    this.getWebsitInfo();
    this.getPcIndexEwm();
  },
  methods: {
    ...mapMutations(["set_websitInfo"]),
    async getWebsitInfo() {
      const { data } = await getWebsitInfo();
      // this.websitInfo = data || [];
      this.set_websitInfo(data);
      this.websitInfo = data || {};
    },
    async getPcIndexEwm() {
      const { data } = await getPcIndexEwm();
      this.ewmList = data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer {
  background-color: #0d7ce4;
  color: #fff;
  min-width: 1400px;
  .main {
    display: flex;
    height: 180px;
    align-items: center;
    .left {
      width: 556px;
      ul {
        display: flex;
        flex-wrap: wrap;
        .left-item {
          width: 50%;
          font-size: 16px;
          font-size: var(--font-size-16);
          font-weight: 500;
          line-height: 22px;
          display: flex;
          margin-bottom: 10px;
        }
      }
    }
    .center {
      display: flex;
      align-items: center;
      .item {
        margin-left: 60px;
      }
    }
    .right {
      display: flex;
      margin-left: auto;
      .ewm-item {
        text-align: center;
        margin-left: 30px;
        .img {
          width: 90px;
          height: 90px;
          background: rgba(0, 0, 0, 0);
          border: 6px solid #ffffff;
          display: block;
        }
        .tit {
          font-size: 14px;
          font-size: var(--font-size-14);
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
          display: block;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
